import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../core/store/store';
import { INavigationState, INavConfig, IGraphEdgeAppearanceConfig } from '../store/store';

export class NavVisOptions {
  static setInvalidNodes(options: vis.Options, validNodes: string[]): void {
    if (options && options.groups) {
      for (const groupName in options.groups) {
        if (!validNodes.includes(groupName)) {
          options.groups[groupName] = Object.assign(options.groups[groupName] || {}, {
            color: {
              background: '#c9c9c9',
              border: '#919191',
              highlight: {
                background: '#c9c9c9',
                border: '#919191',
              },
              hover: {
                background: '#c9c9c9',
                border: '#919191',
              }
            },
            font: {
              color: '#5b5b5b',
            }
          });
        }
      }
    }
  }
  public static setVisOptions(options: vis.Options, config: INavConfig): void {
    const appearanceSettings = config.appearance;
    if (
      !appearanceSettings ||
      !appearanceSettings.graph ||
      !appearanceSettings.graph.documents
    ) {
      return;
    }
    if (!options.groups) {
      options.groups = {};
    }
    for (const propName of Object.getOwnPropertyNames(appearanceSettings.graph.documents)) {
      const sourceGroup = appearanceSettings.graph.documents[propName];
      if (sourceGroup) {
        options.groups[propName] = {};
        const targetGroup = options.groups[propName];
        this.setColors(sourceGroup, targetGroup);
        this.setShape(sourceGroup, targetGroup);
        this.setFontColor(sourceGroup, targetGroup);
      }
    }
  }

  public static setEdgeConfig(name: string, edge: vis.Edge, config: INavConfig): void {
    const appearanceSettings = config.appearance;
    if (
      !appearanceSettings ||
      !appearanceSettings.graph ||
      !appearanceSettings.graph.edges ||
      !name
    ) {
      return;
    }
    const edgeConfig = appearanceSettings.graph.edges[name];
    if (edgeConfig) {
      NavVisOptions.setEdgeColors(edgeConfig, edge);
      NavVisOptions.setEdgeFont(edgeConfig, edge);
      NavVisOptions.setEdgeStyles(edgeConfig, edge);
    }
  }

  private static setEdgeColors(edgeConfig: IGraphEdgeAppearanceConfig, edge: any) {
    if (!edge.color) {
      edge.color = {};
    }
    if (edgeConfig.color) {
      edge.color.color = edgeConfig.color;
      edge.color.highlight = edgeConfig.color;
      edge.color.hover = edgeConfig.color;
    }
  }

  private static setEdgeFont(edgeConfig: IGraphEdgeAppearanceConfig, edge: any) {
    if (!edge.font) {
      edge.font = {};
    }
    if (edgeConfig.fontsize) {
      edge.font.size = edgeConfig.fontsize;
    }
    if (edgeConfig.fontcolor) {
      edge.font.color = edgeConfig.fontcolor;
    }
  }

  private static setEdgeStyles(edgeConfig: IGraphEdgeAppearanceConfig, edge: any) {
    if (edgeConfig.dashes) {
      edge.dashes = edgeConfig.dashes === 'true';
    }
    if (edgeConfig.width) {
      edge.width = edgeConfig.width;
      edge.hoverWidth = (width) => width * 1.5;
      edge.selectionWidth = (width) => width * 1.5;
    }
  }

  private static setShape(sourceGroup: any, targetGroup: any) {
    if (sourceGroup.shape) {
      targetGroup.shape = sourceGroup.shape;
    }
  }

  private static setColors(sourceGroup: any, targetGroup: any) {
    if (sourceGroup.background) {
      const rgb = this.hexToRgb(sourceGroup.background);
      if (!rgb) {
        targetGroup.color = {
          background: sourceGroup.background,
          border: sourceGroup.border || sourceGroup.background,
        };
      } else {
        targetGroup.color = {
          background: `rgb(${rgb.r},${rgb.g},${rgb.b})`,
          border: sourceGroup.border || `rgb(` +
            `${Math.max(rgb.r - 100, 0)},` +
            `${Math.max(rgb.g - 100, 0)},` +
            `${Math.max(rgb.b - 100, 0)})`,
          highlight: {
            background: `rgb(` +
              `${Math.min(rgb.r + 100, 255)},` +
              `${Math.min(rgb.g + 100, 255)},` +
              `${Math.min(rgb.b + 100, 255)})`,
          },
          hover: {
            background: `rgb(` +
              `${Math.min(rgb.r + 100, 255)},` +
              `${Math.min(rgb.g + 100, 255)},` +
              `${Math.min(rgb.b + 100, 255)})`,
            border: sourceGroup.border || `rgb(` +
              `${Math.max(rgb.r - 100, 0)},` +
              `${Math.max(rgb.g - 100, 0)},` +
              `${Math.max(rgb.b - 100, 0)})`,
          },
        };
      }
    }
  }

  private static setFontColor(sourceGroup: any, targetGroup: any) {
    if (!targetGroup.font) {
      targetGroup.font = {};
    }
    if (sourceGroup.fontcolor) {
      targetGroup.font.color = sourceGroup.fontcolor;
    } else if (sourceGroup.background) {
      const rgb = this.hexToRgb(sourceGroup.background);
      const luminance = (rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114) / 255;
      const fontColor = luminance > 0.5 ? '#000000' : '#FFFFFF';
      targetGroup.font.color = fontColor;
    }
  }
  private static hexToRgb(hex: string) {
    const shortPattern = /^#?(a-f\d)(a-f\d)(a-f\d)$/i;
    const shortMatches = shortPattern.exec(hex);
    if (shortMatches) {
      const [a, r, g, b] = shortMatches;
      hex = '#' + r + r + g + g + b + b;
    }
    const pattern = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
    const matches = pattern.exec(hex);
    if (matches) {
      const [a, r, g, b] = matches;
      return {
        r: parseInt(r, 16),
        g: parseInt(g, 16),
        b: parseInt(b, 16),
      };
    }
    return undefined;
  }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/model/nav-vis-options.ts